export default {
  sm: `
  세계를 잇는 하나의 거점<br>데이터센터 각 글로벌
  `,
};
